// True when the page was opened from a Supabase password-recovery email.
// With the implicit flow the redirect carries type=recovery in the URL
// hash. supabase-js emits PASSWORD_RECOVERY for it from a timeout during
// client initialisation, which runs before any React subscriber exists, so
// the event is lost and the user would land signed in without ever being
// asked for a new password (issue #449). The hash itself survives, so it is
// read directly at startup.
export function isRecoveryHash(hash: string): boolean {
  return new URLSearchParams(hash.replace(/^#/, '')).get('type') === 'recovery';
}
